<template>
<!-- 听书精选组合更多 -->
    <div class="main">
        <div class="title">
            精选组合
            <div @click="back" class="back">
                <img src="icon/learnIcon/icon_liucheng_fanhui1.svg" alt="">
            </div>
        </div>
        <div class="rob_list">
            <div @click="toDetail(item.id)" class="rob_item" v-for="(item , index) in dataList" :key="index">
                    <div class="rob_img">
                        <img :src="item.coverImg" alt="">
                    </div>
                    <div class="rob_content">
                        <div class="item_title">{{item.title}}</div>
                        <div class="rob_state">
                            <span> {{item.introduce}}</span>
                            <!-- <span>已更新{{item.updateCount}}节课/共{{item.totalCount}}节课</span>  -->
                        </div>
                        <div class="rob_bottom">
                            <div class="rob_listen">
                                <!-- <span class="limit_title"></span><span class="price_title">￥{{item.price}}</span><del class="del_price">原价￥{{item.lineThroughPrice}}</del> -->
                                <span>{{item.playCount||0}}人收听</span>
                            </div>
                            <div class="bottom_span">
                                <!-- <span>{{item.learnCount}}人在学</span> -->
                                <span>已更新{{item.segCount||0}}本</span>
                            </div>
                        </div>
                    </div>
            </div>
        </div>









       <!-- <div class="bg-img">
           <router-link to="/learn">
                <img class="back-learn" src="icon/back_icon.svg"/>
           </router-link>
           <img class="bg-detail-img" :src="dataList[0].coverImg" alt="">
           <h3>{{title}}</h3>
           <span>{{desc}}</span>
       </div>
        <div class="bg-frame">
            <div class="content-module">
                <div class="ad-card">
                    <div class="ad-img">
                        <img :src="dataList[0].coverImg" alt="">
                    </div>
                    <div class="ad-content">
                        <h3>{{dataList[0].title}}</h3>
                        <div class="ad-parameter">
                            <span class="par-margin">{{dataList[0].playCount||0}}人收听</span>
                            <span>已更新{{dataList[0].segCount||0}}本</span>
                        </div>
                        <div  @click="toDetail(dataList[0].id)" class="go-learn">
                            <img src="icon/learnIcon/golearn-play.svg" alt="">
                            <span>去学习</span>
                        </div>
                    </div>
                </div>
                <div class="content">
                    <ul>
                      <li class="choiceness-model" v-for="(item , index) in dataList" :key="index"  @click="toDetail(item.id)">
                            <div class="choiceness-img">
                            <img class="cover item-img" :src="item.coverImg" alt="精选图片">
                            <img class="play-icon" src="icon/learnIcon/choiceness-play.svg" alt="精选播放图标">
                            </div>
                            <h3>{{item.title}}</h3>
                             <div class="introduce">
                                {{item.introduce}}
                            </div>
                            <div class="parameter">
                                <span class="IitenIn">{{item.playCount||0}}人收听</span>
                                <span class="update">已更新{{item.segCount||0}}本</span>
                            </div>

                      </li>
                  </ul>

                   <div class="bottom-tip">
                        <span>-没有更多啦-</span>
                    </div>

                    <div class="alignCenter colorCCC bold" v-show="status == 'ready' && dataList.length < 1">
                        <img src="notice/no_content.png" width="206" height="143" alt="暂时没有任何内容" />
                    </div>
                </div>
            </div>
        </div> -->


    </div>
</template>
<script>

// part
import shixunPagePart from '@/components/shixunApp/shixunPagePart';

import appConfig from '../../../appConfig';

// util
import browserHelper from '@util/browserHelper';
import deviceHelper from '@util/deviceHelper';
import appHelper from '@util/appHelper';
import wechatHelper from '@util/wechatHelper';

const config = {
    apiConfig : {
        list : {
            url : 'portal/api/audio',
            params:{
                type:4
            },
            dataPath : 'data.records',
            totalPath : 'data.total',
            totalPagePath : 'data.pages'
        }
    }
};



export default {
     name: "choicenessMore",
    extends : shixunPagePart,

    data(){
        return {

            enableDataList : true,
            autoLoadDataList : true,
            // scrollToLoadNextPage:false,
            apiConfig : config.apiConfig,
            title:'精选组合',
            desc : '精选好课组合学习，快速提升能力'
        }
    },
     components: {
    },


    methods:{
         toDetail(id){
            this.$router.push({name:'albumID',params: {id:id}})
        },
        back(){
             appHelper.back(this)
        },

        setWechatShare : function() {

            let wechatShareOptions = {
                title   : appHelper.getTitle(),
                desc    : this.desc,
                link    : location.href,
                imgUrl  : appHelper.getAppIcon() // 分享图标
            };

            wechatHelper.setShare(wechatShareOptions);
        }

    },
    mounted(){

        appHelper.setTitle(this.title);

        if (deviceHelper.isBrowser && browserHelper.isWechat)
        {
            this.setWechatShare();
        }
    }
}
</script>
<style scoped lang="scss">

    div,ul,li,input,h1,h2,h3,h4,h5,h6 {
        margin: 0;
        padding: 0;
    }

    .main{
        position: relative;
        width: 100%;
        background: #fff;
        padding: 0 4%;
        box-sizing: border-box;
    }


    .title{
    width: 100%;
    height: 44px;
    text-align: center;
    line-height: 44px;

    font-size: 20px;

    font-weight: 500;
    color: #333333;

    overflow: hidden;

}
.back{
    float: left;
    margin-top: 4px;
}

.rob_list{
    width: 100%;
    // padding: 0 0px 18px;
    margin-top: 14px;
    box-sizing: border-box;
}

.rob_item{
    width: 100%;
    // height: 78px;
    height: 102px;
    margin-bottom: 16px;
    display: flex;

    .rob_img{
    // width: 100px;
    // height: 78px;
    width: 102px;
    height: 102px;
    border-radius: 4px;
    margin-right: 8px;

    img{
        width: 100%;
        height: 100%;
        object-fit: cover;
        background: #ccc;
        border-radius: 4px;
    }
}


    .rob_content{
    flex: 1;
    height: 100%;
    padding: 13px 0;
    box-sizing: border-box;
     overflow: hidden;


}
}







.item_title{
    height: 18px;


    font-size: 14px;

    font-weight: 500;
    // line-height: 18px;
    color: #333333;

    // margin-top: 4px;
    margin-bottom: 8px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.rob_state{

    font-size: 12px;

    font-weight: 400;
    // line-height: 11px;
    color: #8994A9;


     overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    span{

        color: #999999;

    }

}
.rob_listen{

    font-size: 10px;

    font-weight: 400;
    // line-height: 18px;
    color: #8994A9;

}



.limit_title{

    font-size: 10px;

    font-weight: 500;
    color: #333333;

}
.price_title{

    font-size: 18px;

    font-weight: 500;
    color: #FC3439;

    margin-right: 5px;
}

.del_price{

    font-size: 11px;

    font-weight: 500;
    color: #999999;

    margin-bottom: 5px;
}

.rob_bottom{
    height: 26px;
    margin-top: 20px;
    display: flex;
    justify-content: space-between;
}


.rob_btn{
    width: 100%;
    height: 28px;
    display: flex;
    justify-content: center;
    .btn_content{
        width: 218px;
        height: 28px;
        border: 1px solid #FF7377;

        border-radius: 4px;
        text-align: center;
        span{
            font-size: 12px;

            font-weight: 500;
            // line-height: 17px;
            color: #FF7377;

        }
    }
}

.bottom_span{

    font-size: 10px;

    font-weight: 400;
    // line-height: 18px;
    color: #8994A9;

}























    .bottom-tip{
        width: 100%;
        height: 100px;
        line-height: 100px;
        text-align: center;
        span{

            font-size: 12px;

            font-weight: 400;
            color: #BDBDBD;

        }
    }



    .bg-img{
        width: 100%;
        height: 258px;
        background: black;
        .back-learn{
            position: absolute;
            top: 10px;
            left: 4%;
            width: 26px;
            height: 26px;
            z-index: 999;

        }

        .bg-detail-img{
            width: 100%;
            height: 100%;
            background: #D6D6D6;
            filter: blur(10px);

        }

        h3{
            position: absolute;
            left: 4%;
            bottom: 100px;
            font-size: 24px;

            font-weight: 600;
            line-height: 20px;
            color: #FFFFFF;

        }
        span{
            position: absolute;
            left: 4%;
            bottom: 70px;

            font-size: 14px;

            font-weight: 400;
            line-height: 18px;
            color: #FFFFFF;

        }

    }

    .bg-frame{
        position: absolute;
        top: 242px;

        width: 100%;
        height: 573px;
        background: #FFFFFF;

        border-radius: 18px;
    }

    .content-module{
        position: absolute;
        top: -35px;
        left: 50%;
        transform: translateX(-50%);

        width: 92%;
        box-sizing: border-box;
        height: 500px;


        .ad-card{
            width: 100%;
            height: 187px;
            background: #F6F6F6;

            border-radius: 8px;
            .ad-img{
                width: 100%;
                height: 121px;
                background: rgba(0, 0, 0, 0);

                border-radius: 8px;
                img{
                    width: 100%;
                    height: 100%;
                    border-radius: 8px;
                }
            }
            .ad-content{
                position: relative;
                width: 94%;
                height: 66px;
                margin: 0 auto;
                h3{
                    padding-top: 8px;
                    height: 22px;
                    font-size: 16px;

                    font-weight: 600;
                    line-height: 22px;
                    color: #333333;

                }

                .ad-parameter{
                    padding-top: 8px;
                    height: 17px;
                    font-size: 12px;

                    font-weight: 400;
                    line-height: 17px;
                    color: #999999;

                    .par-margin{
                        margin-right: 24px;
                    }
                }


                .go-learn{
                    position: absolute;
                    right: 0;
                    top: 50%;
                    transform: translateY(-50%);
                    padding: 0 20px;
                    height: 34px;
                    line-height: 34px;
                    background: linear-gradient(159deg, #FE7247 0%, #FF3E5B 100%);

                    border-radius: 17px;
                    box-shadow: 4px 4px 10px #ffc3cb;
                    img{
                        width: 11px;
                        height: 16px;
                        vertical-align:middle;
                        margin-right: 6px;
                    }
                    span{

                        font-size: 14px;

                        font-weight: 400;
                        color: #FFFFFF;

                    }
                }
            }


        }
    }



    //精选组样式
    .content{
        ul{
            width: 100%;
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;

            .choiceness-model{
                width: 48%;
                // float: left;
                list-style: none;
                padding-top: 24px;
                // margin-right: 7px;

                .choiceness-img{
                    width: 100%;
                    height: 116px;
                    border-radius: 6px;
                    position: relative;
                    background: #999999;
                    .item-img{
                        width: 100%;
                        height: 100%;
                        border-radius: 6px;
                    }
                    .play-icon{
                        position: absolute;
                        bottom: 8px;
                        right: 8px;
                        width: 26px;
                        height: 26px;
                    }

                }
                h3{
                    font-size: 16px;
                    height: 22px;

                    font-weight: 600;
                    color: #333333;

                    margin-bottom: 2px;
                    margin-top: 4px;
                    white-space:nowrap;
                    overflow:hidden;
                    text-overflow:ellipsis;
                }

                 .introduce{
                    width: 100%;
                    font-size: 12px;

                    font-weight: 400;
                    color: #7A7A7A;

                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    margin-bottom: 4px;

                }

                .parameter{
                    font-size: 10px;

                    font-weight: 400;
                    color: #999999;

                    .IitenIn{
                        // display: block;
                        margin-right: 18px;
                    }
                    .update{
                        // display: block;

                    }
                }

            }
        }
    }

</style>
